import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import FullScreenLoader from '../components/Loader';
import Container from '../components/Container';
import { Trash } from 'lucide-react';

const WebLoginPage = () => {
  const [qrValue, setQrValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [loggedInUsers, setLoggedInUsers] = useState([]);

  const fetchQRCode = async () => {
    try {
      const res = await api.get('/whatsapp/qr');
      if (res.status === 200) {
        setQrValue(res.data.qr);
      }
    } catch (err) {
      console.error("QR Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const checkWaStatus = async () => {
    try {
      const res = await api.get('/whatsapp/checkStatus');
      if (res.status === 200) {
        localStorage.setItem('loggedIn', res?.data?.loggedIn);
        setLoggedInUsers(res.data?.data || []);
      }
    } catch (err) {
      localStorage.setItem('loggedIn', false);
      console.error("Status Check Error:", err);
    }
  };

  const logoutWhatsapp = async (phone) => {
    
    if(window.confirm("Are you sure you want to logout this session?")){
      try {
        const res = await api.get('/whatsapp/logout/'+phone);
        if (res.status === 200) {
          localStorage.setItem('loggedIn', res?.data?.loggedIn);
          setLoggedInUsers(res.data?.data || []);
        }
      } catch (err) {
        localStorage.setItem('loggedIn', false);
        console.error("Status Check Error:", err);
      }
    }
  };

  useEffect(() => {
    fetchQRCode();
    checkWaStatus();

    const interval = setInterval(() => {
      fetchQRCode();
      checkWaStatus();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Container title={'WhatsApp Sessions'} onClick={()=>{
      setLoading(true);
      fetchQRCode();
      checkWaStatus();
    }}>
      {loading && <FullScreenLoader />}

      <div style={mainLayout}>
        <div style={{...cardStyle,flex:'1.5 1'}}>
            {(loggedInUsers?.length)?
              <div style={cardHeader}>
                <div style={statusDot}></div>
                <h3 style={cardTitle}>Connected Sessions</h3>
              </div>
            :
              <div style={cardHeader}>
                <div style={redStatusDot}></div>
                <h3 style={cardTitle}>No Active Sessions</h3>
              </div>
            }
          
          <div style={scrollArea}>
            {loggedInUsers.length > 0 ? (
              <table style={tableStyle}>
                <tbody>
                  {loggedInUsers.map((user, index) => (
                    <tr key={index} style={rowStyle}>
                      <td style={tdStyle}>
                        <div style={userIcon}>👤</div>
                        <div style={{width:'80%'}}>
                          <div style={userName}>{user.name || "Unknown User"}</div>
                          <div style={userPhone}>{user.phone || "N/A"}</div>
                        </div>
                        <div style={{cursor:'pointer',color:'red'}}><Trash onClick={() => logoutWhatsapp(user.phone)} /></div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div style={emptyState}>
                <p>No active sessions found.</p>
                <small>Scan the QR code to connect</small>
              </div>
            )}
          </div>
        </div>

        <div style={qrCardStyle}>
          <h3 style={cardTitle}>Link New Device</h3>
          <p style={subTextStyle}>Open WhatsApp on your phone and scan the code</p>
          
          <div style={qrBoxStyle}>
            {qrValue ? (
              <img src={qrValue} alt="QR Code" style={qrImageStyle} />
            ) : (
              <div style={loaderContainer}>
                <div className="spinner" style={spinnerStyle}></div>
                <p style={{ marginTop: '15px', color: '#888', fontSize: '14px' }}>Fetching secure QR...</p>
              </div>
            )}
          </div>

          <button 
            onClick={() => {
              setLoading(true);
              setQrValue('');
              fetchQRCode();
            }} 
            style={btnStyle}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1da851'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#25D366'}
          >
            Refresh QR Code
          </button>
        </div>
      </div>
    </Container>
  );
};


const mainLayout = {
  display: 'flex',
  gap: '30px',
  flexWrap: 'wrap',
  padding: '20px 0',
};

const cardStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '16px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
  padding: '24px',
  border: '1px solid #f0f0f0',
  display: 'flex',
  flexDirection: 'column',
};

const cardHeader = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '20px',
  borderBottom: '1px solid #f0f0f0',
  paddingBottom: '12px'
};

const cardTitle = {
  margin: 0,
  fontSize: '18px',
  color: '#1c1e21',
  fontWeight: '600',
};

const qrCardStyle = {
  ...cardStyle,
  textAlign: 'center',
  height: 'fit-content',
  position: 'sticky',
  top: '20px',
  flex:'0.6'
};

const statusDot = {
  width: '10px',
  height: '10px',
  backgroundColor: '#25D366',
  borderRadius: '50%',
  marginRight: '10px',
  boxShadow: '0 0 8px rgba(37, 211, 102, 0.5)'
};

const redStatusDot = {
  width: '10px',
  height: '10px',
  backgroundColor: '#f11919',
  borderRadius: '50%',
  marginRight: '10px',
  boxShadow: '0 0 8px rgba(211, 37, 37, 0.5)'
};

const scrollArea = {
  minHeight: '200px',
  maxHeight:'700px',
  overflowY: 'auto',

};

const tableStyle = {
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: '0 8px',
};

const rowStyle = {
  backgroundColor: '#f8f9fa',
  transition: 'transform 0.2s',
  borderRadius: '8px',
};

const tdStyle = {
  padding: '12px 16px',
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
};

const userIcon = {
  width: '40px',
  height: '40px',
  backgroundColor: '#e7f8ef',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '20px'
};

const userName = { fontWeight: '600', color: '#333', fontSize: '15px' };
const userPhone = { color: '#777', fontSize: '13px' };

const subTextStyle = {
  fontSize: '14px',
  color: '#666',
  marginBottom: '20px'
};

const qrBoxStyle = {
  display:'flex',
  justifyContent:'center', 
  background: '#fff',
  padding: '15px',
  borderRadius: '12px',
  border: '2px dashed #e0e0e0',
  marginBottom: '20px',
};

const qrImageStyle = {
  width: '240px',
  height: '240px',
  display: 'block'
};

const btnStyle = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#007bff',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  fontSize: '15px',
  fontWeight: '600',
  transition: 'all 0.3s ease',
};

const emptyState = {
  textAlign: 'center',
  padding: '40px 0',
  color: '#999'
};

const spinnerStyle = {
  width: '40px',
  height: '40px',
  border: '4px solid #f3f3f3',
  borderTop: '4px solid #25D366',
  borderRadius: '50%',
};

const loaderContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '240px',
  width: '240px'
};

export default WebLoginPage;